module.exports = __webpack_public_path__ + "static/v2-d6ad85cf5fd18754f0c318d9c7e5827c.png";